import { VyPaper } from '../../data-display/VyPaper/VyPaper.tsx';
import { FC, ReactNode } from 'react';

type VyRadioCardV2Props = {
  isSelected: boolean;
  renderContent: (isSelected: boolean) => ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

export const VyRadioCardWrapper: FC<VyRadioCardV2Props> = ({
  isSelected,
  renderContent,
  onClick,
  disabled = false,
}) => {
  return (
    <VyPaper
      sx={{
        flex: 1,
        padding: '12px',
        border: isSelected ? '1px solid #020F20' : '1px solid #E8EBF2',
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: isSelected ? '#fff' : '#F5F6FA',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease-in-out',
        '&:hover': disabled
          ? undefined
          : {
              borderColor: '#5EA3EF',
            },
      }}
      onClick={disabled ? undefined : onClick}
    >
      {renderContent(isSelected)}
    </VyPaper>
  );
};
